const AKTA_CATEGORIES = [
  {
    label: "Home",
    collections: [
      "home",
      "glassware",
      "floral-and-vases",
      "decor",
      "throws-and-pillows",
      "diffusers",
      "aromas",
      "bed-and-bath",
    ],
  },
  {
    label: "His",
    collections: ["his", "duffel-collection", "on-the-go"],
  },
  {
    label: "For Her",
    collections: ["for-her", "skincare", "accessories", "perfumes-and-oils"],
  },
  {
    label: "Moments",
    collections: ["moments", "get-well", "seasonal", "shop-gifts", "box-gifts"],
  },
  {
    label: "Bebe",
    collections: [
      "bebe",
      "baby-and-toddler",
      "blankets-bonnets-and-swaddle",
      "toys-and-accessories",
      "boys",
      "girls",
      "school-collection",
      "teen",
      "bags",
    ],
  },
  {
    label: "Bliss",
    collections: ["bliss", "self-care", "bath-and-body"],
  },
];

const AKTA_STEP1_EXTRA_SOURCES = ["all"];

const AKTA_HIDE_ADDONS_FROM_STEP1 = true;

const AKTA_SOLD_OUT_LAST = true;

const AKTA_EXCLUDE_HANDLES = [
  // "gift-card",
];

const AKTA_OVERRIDES = {
  // "silk-scarf-ivory": ["For Her", "Bliss"],
};

const AKTA_FETCH_CONCURRENCY = 4;

const AKTA_DEBUG = false;

class AktaBuildBoxApp {
  constructor() {
    const savedState = this.loadState();
    const initialCart = savedState?.cart || [];
    let initialStep = savedState?.step || 1;

    if (initialStep === 3 && initialCart.length === 0) initialStep = 1;

    const config = window.aktaBoxCollections || {};

    this.config = {
      root: config.root || (window.Shopify?.routes?.root ?? "/"),
      step1: Array.isArray(config.step1) ? config.step1 : [],
      step2: Array.isArray(config.step2) ? config.step2 : [],
      pageSize: 250,
      maxPages: 4,
    };

    this.state = {
      step: initialStep,
      cart: initialCart,
      message: savedState?.message || "",
      collections: { step1: [], step2: [] },
      loading: true,
    };

    this.elements = {
      stepperItems: document.querySelectorAll(".akta-step"),
      views: document.querySelectorAll(".akta-view"),
      grid1: document.getElementById("akta-grid-step-1"),
      grid2: document.getElementById("akta-grid-step-2"),
      filterContainer: document.getElementById("akta-filters"),
      footer: document.getElementById("akta-box-footer"),
      footerOuter: document.querySelector(".cart-item_footer"),
      footerList: document.getElementById("akta-footer-list"),
      totalPrice: document.getElementById("akta-total-price"),
      btnBack: document.getElementById("akta-btn-back"),
      btnNext: document.getElementById("akta-btn-next"),
      messageInput: document.getElementById("akta-message-input"),
    };

    if (this.elements.messageInput) {
      this.elements.messageInput.value = this.state.message || "";
    }

    this.init();
  }

  loadState() {
    try {
      const s = localStorage.getItem("akta-box-state");
      return s ? JSON.parse(s) : null;
    } catch (err) {
      console.error("Error loading state:", err);
      return null;
    }
  }

  saveState() {
    try {
      localStorage.setItem(
        "akta-box-state",
        JSON.stringify({
          step: this.state.step,
          cart: this.state.cart,
          message: this.state.message,
        })
      );
    } catch (err) {
      console.error("Error saving state:", err);
    }
  }

  clearState() {
    try {
      localStorage.removeItem("akta-box-state");
    } catch (err) {
      console.error("Error clearing state:", err);
    }
  }

  injectStyles() {
    if (document.getElementById("akta-buildbox-no-anim-style")) return;

    const style = document.createElement("style");
    style.id = "akta-buildbox-no-anim-style";
    style.textContent = `
      #akta-build-a-box-app .akta-view{
        display: none !important;
        opacity: 1 !important;
        height: auto !important;
        max-height: none !important;
        overflow: visible !important;
        transition: none !important;
        animation: none !important;
      }
      #akta-build-a-box-app .akta-view.active{
        display: block !important;
      }
      #akta-build-a-box-app .akta-step.disabled{
        cursor: not-allowed !important;
      }
      #akta-build-a-box-app .akta-btn.is-disabled{
        cursor: not-allowed !important;
      }
      #akta-build-a-box-app .akta-empty-state{
        grid-column: 1 / -1;
        text-align: center;
        padding: 60px 20px;
        font-family: Gilroy, sans-serif;
        font-size: 16px;
        color: #4C503D;
      }
      #akta-build-a-box-app .akta-skeleton{
        background: rgba(247, 240, 230, 1);
        min-height: 340px;
      }
    `;
    document.head.appendChild(style);
  }

  async init() {
    this.injectStyles();
    this.addEventListeners();
    this.updateUI({ scrollTop: false });
    this.renderFooter();

    this.showSkeletons(this.elements.grid1, 8);
    this.showSkeletons(this.elements.grid2, 4);

    await this.loadStep("step2", this.elements.grid2);
    await this.loadStep("step1", this.elements.grid1);

    this.state.loading = false;
  }

  showSkeletons(container, count) {
    if (!container) return;
    container.innerHTML = Array.from({ length: count })
      .map(() => `<div class="akta-card akta-skeleton"></div>`)
      .join("");
  }

  buildSourceList(key) {
    if (key !== "step1") {
      return (this.config[key] || []).map((c) => ({
        handle: c.handle,
        labels: [],
      }));
    }

    const byHandle = new Map();

    AKTA_CATEGORIES.forEach((cat) => {
      (cat.collections || []).forEach((h) => {
        const handle = String(h).trim().toLowerCase();
        if (!handle) return;
        if (!byHandle.has(handle)) byHandle.set(handle, { handle, labels: [] });
        const entry = byHandle.get(handle);
        if (!entry.labels.includes(cat.label)) entry.labels.push(cat.label);
      });
    });

    const sources = Array.from(byHandle.values());
    const seen = new Set(sources.map((s) => s.handle));

    (this.config.step1 || []).forEach((c) => {
      const handle = String(c.handle || "").toLowerCase();
      if (handle && !seen.has(handle)) {
        sources.push({ handle, labels: [] });
        seen.add(handle);
      }
    });

    AKTA_STEP1_EXTRA_SOURCES.forEach((h) => {
      const handle = String(h).trim().toLowerCase();
      if (handle && !seen.has(handle)) {
        sources.push({ handle, labels: [] });
        seen.add(handle);
      }
    });

    return sources;
  }

  sortSoldOutLast(list) {
    if (!AKTA_SOLD_OUT_LAST) return list;

    return list
      .map((p, i) => ({ p, i }))
      .sort((a, b) => {
        const av = a.p.available === false ? 1 : 0;
        const bv = b.p.available === false ? 1 : 0;
        return av - bv || a.i - b.i;
      })
      .map((x) => x.p);
  }

  async loadStep(key, grid) {
    const list = this.buildSourceList(key);

    if (!list.length) {
      if (grid) {
        grid.innerHTML = `<p class="akta-empty-state">No collections selected yet. Add them in the theme editor.</p>`;
      }
      if (key === "step1" && this.elements.filterContainer) {
        this.elements.filterContainer.innerHTML = "";
      }
      return;
    }

    const collected = [];

    for (let i = 0; i < list.length; i += AKTA_FETCH_CONCURRENCY) {
      const batch = list.slice(i, i + AKTA_FETCH_CONCURRENCY);

      await Promise.all(
        batch.map(async (entry) => {
          try {
            const products = await this.fetchCollection(entry.handle);
            products.forEach((p) => {
              const item = this.normalizeProduct(p, entry);
              if (item) collected.push(item);
            });
            if (AKTA_DEBUG) {
              console.log(`[Akta Build a Box] ${entry.handle}: ${products.length}`);
            }
          } catch (err) {
            console.error(
              `[Akta Build a Box] Failed to load "${entry.handle}":`,
              err.message
            );
          }
        })
      );
    }

    let final = this.dedupe(collected);

    if (AKTA_EXCLUDE_HANDLES.length) {
      const skip = new Set(AKTA_EXCLUDE_HANDLES.map((h) => String(h).toLowerCase()));
      final = final.filter((p) => !skip.has(String(p.handle || "").toLowerCase()));
    }

    if (key === "step1" && AKTA_HIDE_ADDONS_FROM_STEP1) {
      const addonIds = new Set((this.state.collections.step2 || []).map((p) => p.id));
      if (addonIds.size) final = final.filter((p) => !addonIds.has(p.id));
    }

    final = this.sortSoldOutLast(final);

    this.state.collections[key] = final;

    if (AKTA_DEBUG) {
      console.log(`[Akta Build a Box] ${key} total: ${final.length}`);
      const counts = {};
      final.forEach((p) => {
        if (!p.cats.length) {
          counts["(uncategorised)"] = (counts["(uncategorised)"] || 0) + 1;
        }
        p.cats.forEach((c) => (counts[c] = (counts[c] || 0) + 1));
      });
      console.log("[Akta Build a Box] per category:", counts);
    }

    if (key === "step1") this.renderStep1();
    else this.renderStep2();

    this.updateGridButtons();
  }

  async fetchCollection(handle) {
    const all = [];
    const { root, pageSize, maxPages } = this.config;

    for (let page = 1; page <= maxPages; page++) {
      const url = `${root}collections/${encodeURIComponent(
        handle
      )}/products.json?limit=${pageSize}&page=${page}`;

      const res = await fetch(url, { headers: { Accept: "application/json" } });
      if (!res.ok) throw new Error(`HTTP ${res.status} for ${handle}`);

      const data = await res.json();
      const products = data.products || [];
      all.push(...products);

      if (products.length < pageSize) break;
    }

    return all;
  }

  normalizeProduct(raw, entry) {
    const variants = raw.variants || [];
    if (!variants.length) return null;

    const variant = variants.find((v) => v.available) || variants[0];
    if (!variant || variant.id == null) return null;

    const priceCents = Math.round(parseFloat(variant.price || "0") * 100);

    let image = "";
    const src = variant.featured_image?.src || raw.images?.[0]?.src || "";
    if (src) image = src.includes("?") ? `${src}&width=400` : `${src}?width=400`;

    const handle = raw.handle || "";
    const cats = AKTA_OVERRIDES[handle]
      ? AKTA_OVERRIDES[handle].slice()
      : (entry.labels || []).slice();

    return {
      id: variant.id,
      title: raw.title || "",
      price: isNaN(priceCents) ? 0 : priceCents,
      image,
      handle,
      available: variants.some((v) => v.available),
      collection_handle: entry.handle,
      cats,
    };
  }

  dedupe(arr) {
    const map = new Map();
    const result = [];

    arr.forEach((p) => {
      if (!p || p.id == null) return;

      if (map.has(p.id)) {
        const existing = map.get(p.id);
        if (
          p.collection_handle &&
          !existing.collection_handles.includes(p.collection_handle)
        ) {
          existing.collection_handles.push(p.collection_handle);
        }
        (p.cats || []).forEach((c) => {
          if (!existing.cats.includes(c)) existing.cats.push(c);
        });
      } else {
        const item = {
          ...p,
          cats: Array.isArray(p.cats) ? p.cats.slice() : [],
          collection_handles: p.collection_handle ? [p.collection_handle] : [],
        };
        map.set(p.id, item);
        result.push(item);
      }
    });

    return result;
  }

  canGoToStep(step) {
    if (step === 1 || step === 2) return true;
    if (step === 3) return this.state.cart.length > 0;
    return false;
  }

  goToStep(step, { scrollTop = false } = {}) {
    if (step < 1 || step > 3) return;

    if (!this.canGoToStep(step)) {
      alert("To go to Step 3, first select at least one product.");
      return;
    }

    this.state.step = step;
    this.saveState();
    this.updateUI({ scrollTop });
  }

  changeStep(direction) {
    const nextStep = this.state.step + direction;
    if (nextStep < 1 || nextStep > 3) return;

    if (!this.canGoToStep(nextStep)) {
      alert("To go to Step 3, first select at least one product.");
      return;
    }

    this.state.step = nextStep;
    this.saveState();
    this.updateUI({ scrollTop: true });
  }

  addEventListeners() {
    this.elements.btnBack?.addEventListener("click", () => this.changeStep(-1));

    this.elements.btnNext?.addEventListener("click", () => {
      if (this.state.step === 3) this.addToCart();
      else this.changeStep(1);
    });

    this.elements.stepperItems.forEach((stepEl) => {
      stepEl.addEventListener("click", () => {
        const target = parseInt(stepEl.dataset.step, 10);
        if (target === 1 || target === 2) {
          this.goToStep(target, { scrollTop: false });
        }
      });
    });

    if (this.elements.messageInput) {
      this.elements.messageInput.addEventListener("input", (e) => {
        this.state.message = e.target.value;
        this.saveState();
      });
    }

    if (this.elements.filterContainer) {
      this.elements.filterContainer.addEventListener("click", (e) => {
        const btn = e.target.closest(".akta-filter-btn");
        if (!btn) return;
        this.filterGrid(btn.dataset.filter);
        this.elements.filterContainer
          .querySelectorAll(".akta-filter-btn")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
      });
    }

    [this.elements.grid1, this.elements.grid2].forEach((grid) => {
      if (!grid) return;
      grid.addEventListener("click", (e) => {
        const btn = e.target.closest(".akta-card__add-btn");
        if (!btn || btn.disabled) return;

        this.toggleItem({
          id: parseInt(btn.dataset.id, 10),
          title: btn.dataset.title,
          price: parseInt(btn.dataset.price, 10),
          image: btn.dataset.image,
        });
      });
    });

    this.elements.footerList?.addEventListener("click", (e) => {
      const removeBtn = e.target.closest(".akta-build-box-footer-item__remove");
      if (!removeBtn) return;
      this.removeItem(parseInt(removeBtn.dataset.id, 10));
    });
  }

  toggleItem(product) {
    const index = this.state.cart.findIndex((item) => item.id === product.id);
    if (index > -1) this.state.cart.splice(index, 1);
    else this.state.cart.push(product);

    this.saveState();
    this.renderFooter();
    this.updateGridButtons();

    if (this.state.step === 3 && this.state.cart.length === 0) {
      this.state.step = 2;
      this.saveState();
      this.updateUI({ scrollTop: false });
    }
  }

  removeItem(id) {
    this.state.cart = this.state.cart.filter((item) => item.id !== id);
    this.saveState();
    this.renderFooter();
    this.updateGridButtons();

    if (this.state.step === 3 && this.state.cart.length === 0) {
      this.state.step = 2;
      this.saveState();
      this.updateUI({ scrollTop: false });
    }
  }

  updateUI({ scrollTop = true } = {}) {
    this.elements.stepperItems.forEach((el, index) => {
      const stepNum = index + 1;
      el.classList.remove("active", "completed");
      if (stepNum === this.state.step) el.classList.add("active");
      if (stepNum < this.state.step) el.classList.add("completed");
    });

    this.elements.views.forEach((v) => v.classList.remove("active"));
    const activeView = document.getElementById(`akta-view-${this.state.step}`);
    if (activeView) activeView.classList.add("active");

    if (this.elements.btnBack) {
      this.elements.btnBack.style.display = this.state.step === 1 ? "none" : "block";
    }
    if (this.elements.btnNext) {
      this.elements.btnNext.textContent = this.state.step === 3 ? "Add to cart" : "Next";
    }

    if (this.elements.footer) {
      this.elements.footer.classList.toggle("step-3-mode", this.state.step === 3);
    }

    if (scrollTop) window.scrollTo(0, 0);
  }

  renderStep1() {
    const products = this.state.collections.step1 || [];

    const present = new Set();
    products.forEach((p) => (p.cats || []).forEach((c) => present.add(c)));
    const active = AKTA_CATEGORIES.filter((cat) => present.has(cat.label));

    if (this.elements.filterContainer) {
      if (!products.length || !active.length) {
        this.elements.filterContainer.innerHTML = "";
      } else {
        let html = `<button class="akta-filter-btn active" data-filter="all">All</button>`;
        active.forEach((cat) => {
          const safe = this.escapeHTML(cat.label);
          html += `<button class="akta-filter-btn" data-filter="${safe}">${safe}</button>`;
        });
        this.elements.filterContainer.innerHTML = html;
      }
    }

    this.renderGrid(this.elements.grid1, products);
  }

  renderStep2() {
    this.renderGrid(this.elements.grid2, this.state.collections.step2 || []);
  }

  renderGrid(container, products) {
    if (!container) return;

    if (!products || !products.length) {
      container.innerHTML = `<p class="akta-empty-state">No products available in the selected collections.</p>`;
      return;
    }

    container.innerHTML = products.map((p) => this.createCardHTML(p)).join("");
  }

  escapeHTML(str) {
    return String(str ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  createCardHTML(product) {
    const price = (Number(product.price) / 100).toFixed(2);
    const isAvailable = product.available !== false;
    const title = this.escapeHTML(product.title);
    const image = this.escapeHTML(product.image || "");
    const handle = this.escapeHTML(product.handle || "");
    const cats = this.escapeHTML((product.cats || []).join("|"));

    return `
      <div class="akta-card ${!isAvailable ? "is-sold-out" : ""}" data-collections="${cats}">
        <div class="akta-card__image-wrapper">
          ${!isAvailable ? `<span class="akta-card__badge">Sold Out</span>` : ``}
          <img src="${image}" alt="${title}" class="akta-card__image" loading="lazy">
        </div>

        ${
          handle
            ? `<a href="${this.config.root}products/${handle}" class="akta-card__title" target="_blank">${title}</a>`
            : `<div class="akta-card__title">${title}</div>`
        }

        <div class="akta-card__footer">
          <div class="akta-card__price">$${price}</div>
          ${
            isAvailable
              ? `<button
                  class="akta-card__add-btn"
                  data-id="${product.id}"
                  data-title="${title}"
                  data-price="${product.price}"
                  data-image="${image}">
                  Add
                </button>`
              : `<div class="sold__out">Sold Out</div>`
          }
        </div>
      </div>
    `;
  }

  filterGrid(filter) {
    const grid = this.elements.grid1;
    if (!grid) return;
    grid.querySelectorAll(".akta-card").forEach((card) => {
      const cats = (card.dataset.collections || "").split("|").filter(Boolean);
      card.style.display = filter === "all" || cats.includes(filter) ? "" : "none";
    });
  }

  updateGridButtons() {
    document.querySelectorAll(".akta-card__add-btn").forEach((btn) => {
      const id = parseInt(btn.dataset.id, 10);
      const inCart = this.state.cart.some((item) => item.id === id);
      btn.textContent = inCart ? "Selected" : "Add";
      btn.classList.toggle("selected", inCart);
    });
  }

  renderFooter() {
    const hasItems = this.state.cart.length > 0;
    if (this.elements.footerOuter) {
      this.elements.footerOuter.style.display = hasItems ? "" : "none";
    }
    if (this.elements.footer) {
      this.elements.footer.classList.toggle("visible", hasItems);
    }

    if (!this.elements.footerList || !this.elements.totalPrice) return;

    this.elements.footerList.innerHTML = this.state.cart
      .map((item) => {
        const title = this.escapeHTML(item.title || "");
        const short = title.length > 10 ? title.slice(0, 10) + "..." : title;
        return `
          <div class="akta-build-box-footer-item">
            <img src="${this.escapeHTML(item.image || "")}" class="akta-build-box-footer-item__image">
            <div class="akta-build-box-footer-item__title" style="text-transform:uppercase">${short}</div>
            <div class="akta-build-box-footer-item__price">$${(item.price / 100).toFixed(2)}</div>
            <button class="akta-build-box-footer-item__remove" data-id="${item.id}">&times;</button>
          </div>
        `;
      })
      .join("");

    const total = this.state.cart.reduce((sum, item) => sum + Number(item.price || 0), 0);
    this.elements.totalPrice.textContent = "Total Price: $" + (total / 100).toFixed(2);
  }

  async addToCart() {
    const items = this.state.cart.map((item) => ({ id: item.id, quantity: 1 }));
    if (!items.length) {
      alert("Please select at least one item.");
      return;
    }

    try {
      if (this.elements.btnNext) this.elements.btnNext.textContent = "Adding...";
      const res = await fetch(this.config.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items,
          attributes: { "Gift Message": this.state.message },
        }),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || err.message || "Failed to add to cart");
      }

      this.clearState();
      window.location.href = this.config.root + "cart";
    } catch (error) {
      console.error(error);
      if (this.elements.btnNext) this.elements.btnNext.textContent = "Try Again";
      alert(`Issue adding to cart: ${error.message}`);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new AktaBuildBoxApp();
});